import { useRef, useState } from 'react';
import { StudioButton as Button } from './styles';
import { postsService } from '@/core/services/postsService';
import type { Post } from '@/core/models/post';
import { Field, Note } from './styles';
import { useStudioTask } from './useStudioTask';
export function TimelinePicker({
  owner,
  onChoose,
}: {
  owner: string;
  onChoose: (post: Post) => void;
}) {
  const [link, setLink] = useState('');
  const [post, setPost] = useState<Post>();
  const linkRevision = useRef(0);
  const task = useStudioTask();
  async function load() {
    let id = link.trim();
    if (id.includes('/')) {
      const u = new URL(id, location.origin);
      if (
        u.origin !== location.origin &&
        !['truxsocial.org', 'www.truxsocial.org'].includes(u.hostname)
      )
        throw Error('Invalid link');
      if (!/^\/post\/[^/]+(?:\/[^/]+)?\/?$/.test(u.pathname)) throw Error('Invalid post link');
      id = u.pathname.split('/').filter(Boolean).at(-1) ?? '';
    }
    if (!/^[\w-]+$/.test(id)) throw Error('Invalid post');
    let p = await postsService.getPost(id);
    if (p?.thread?.rootId && p.thread.rootId !== p.id)
      p = await postsService.getPost(p.thread.rootId);
    if (
      !p ||
      p.authorId !== owner ||
      p.removed ||
      p.published === false ||
      (p.thread?.count ?? 0) >= 100
    )
      throw Error('Choose your own published post');
    return p;
  }
  return (
    <>
      <Note>
        Link a real follow-up to one of your published posts. It inherits the original audience.
      </Note>
      <Field>
        Post link or ID
        <input
          value={link}
          onChange={(e) => {
            setLink(e.target.value);
            linkRevision.current += 1;
            setPost(undefined);
          }}
        />
      </Field>
      <Button
        disabled={task.busy || !link.trim()}
        onClick={() => {
          const revision = linkRevision.current;
          setPost(undefined);
          void task.run(load, (result) => {
            if (revision === linkRevision.current) setPost(result);
          });
        }}
      >
        Review original post
      </Button>
      {task.error && <p role="alert">Choose a link to your own available, published post.</p>}
      {post && (
        <>
          <blockquote>{post.body}</blockquote>
          <Button variant="primary" onClick={() => onChoose(post)}>
            Continue this timeline
          </Button>
        </>
      )}
    </>
  );
}
